<template>
  <div class="frame">
    <div class="mobile-filler" :class="{ scrolled: $store.state.page.scrolled }"></div>

    <div class="menu">
      <div class="menu__background">
        <MenuContent />
      </div>

      <MainNavigator />
    </div>

    <div class="sidebar">
      <div class="sidebar__up">
        <ComposedLogo />
      </div>
      <div class="sidebar__bottom">
        <FullFooter />
        <Socials v-if="!isMobile" />
      </div>
    </div>
  </div>
</template>

<script>
import MainNavigator from '@/components/frame/MainNavigator.vue';
import ComposedLogo from '@/components/frame/ComposedLogo.vue';
import Socials from '@/components/frame/Socials.vue';
import MenuContent from '@/components/contents/MenuContent.vue';
import FullFooter from '@/components/frame/FullFooter.vue';
import { isMobile } from '@/scripts/utils';

export default {
  components: {
    ComposedLogo,
    Socials,
    MainNavigator,
    MenuContent,
    FullFooter,
  },

  data() {
    return {
      isMobile: isMobile(),
    };
  },
};
</script>

<style lang="scss" scoped>
.frame {
  position: relative;
  z-index: 2;

  .menu {
    position: fixed;
    top: 0px;
    right: 0;
    width: calc(100% - ((100vw / 32) * 5));
    padding-top: calc((100vh / 18) * 1);

    @include mq($until: ipadL) {
      top: 20px;
      right: calc(100vw / 32 * 4);
    }

    &__background {
      @extend %full-fixed;
      background-color: $color-white;
    }
  }

  .sidebar {
    position: fixed;
    left: calc((100vw / 32) * 1);
    top: 0px;
    width: calc((100vw / 32) * 3);
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    padding: calc((100vh / 18) * 1) 0px;

    @include mq($until: ipadL) {
      left: calc((100vw / 32) * 4);
      width: auto;
      height: auto;

      padding: calc((100vh / 18) * 0.5) 0px;
    }

    &__bottom {
      position: relative;
      width: 100%;

      display: flex;
      align-items: center;
      // justify-content: space-between;
    }
  }

  .mobile-filler {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 110px;
    background-color: $color-black;
    transition: transform .6s $inOutCubic,
                opacity .6s $inOutCubic;

    transform: translateY(-100%);
    opacity: 0;

    @at-root .page-white & {
      background-color: $color-white;
    }

    &.scrolled {
      transform: translateY(0px);
      opacity: 1;
    }

    @include mq($until: ipadL) {
      display: block;
    }
  }
}
</style>
